import * as apiAction from '../Store/API/api';
import httpService from 'services/httpService';
const api = ({dispatch, getState}) => next => async action => {
    if(action.type !== apiAction.API_CALL_BEGAN) return next(action);

    const {url,method,data,onStart,onSuccess,onError} = action.payload;
    if(onStart) dispatch({type:onStart});
    next(action);
    // Call API endpoint
    try{
        const response = await httpService.request(
            url,
            method,
            data
        );
        //general Success
        dispatch({type:apiAction.API_CALL_SUCCESS,payload:response.data});
        if(onSuccess) dispatch({type:onSuccess,payload:response.data});
    }catch(error) {
        //general Error
        dispatch({type:apiAction.API_CALL_FAILED,payload:error.message});
        if(onError) dispatch({type:onError,payload:error.message});
    }
};
export default api;